require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./flexlayout"), require("./truncatedtext"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./flexlayout", "./truncatedtext"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./flexlayout"), require("./truncatedtext")) : factory(root["./utils"], root["./flexlayout"], root["./truncatedtext"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__17__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[67],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(555);


/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _ToggleSwitch = _interopRequireDefault(__webpack_require__(556));

exports["default"] = _ToggleSwitch["default"];
exports.ToggleSwitch = _ToggleSwitch["default"];

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _flexlayout = _interopRequireDefault(__webpack_require__(16));

var _lodash = __webpack_require__(20);

var _utils = __webpack_require__(4);

var _truncatedtext = _interopRequireDefault(__webpack_require__(17));

var _baUiCarbon = __webpack_require__(12);

var _ToggleSwitch = _interopRequireDefault(__webpack_require__(557));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var toggleSwitchClassName = _ToggleSwitch["default"].toggleSwitchClassName.replace(/"/g, '');

var BaPropTypes = _utils.propsUtils.BaPropTypes;

var ToggleSwitch = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ToggleSwitch, _Component);

  function ToggleSwitch() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ToggleSwitch.prototype;

  _proto.render = function render() {
    var _ref;

    var _this$props = this.props,
        className = _this$props.className,
        disabled = _this$props.disabled,
        id = _this$props.id,
        labelA = _this$props.labelA,
        labelB = _this$props.labelB,
        onChange = _this$props.onChange,
        onToggle = _this$props.onToggle,
        small = _this$props.small,
        tabIndex = _this$props.tabIndex,
        toggled = _this$props.toggled,
        active = _this$props.active,
        align = _this$props.align,
        checkboxInputExtraOptions = _this$props.checkboxInputExtraOptions,
        checked = _this$props.checked,
        disabledSingular = _this$props.disabledSingular,
        hover = _this$props.hover,
        indeterminate = _this$props.indeterminate,
        label = _this$props.label,
        readOnly = _this$props.readOnly,
        otherToggleProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["className", "disabled", "id", "labelA", "labelB", "onChange", "onToggle", "small", "tabIndex", "toggled", "active", "align", "checkboxInputExtraOptions", "checked", "disabledSingular", "hover", "indeterminate", "label", "readOnly"]);
    var displayLabel = this.props.displayLabel;
    var mappedDisabled = disabled != null ? disabled : disabledSingular;
    var mappedId = id != null ? id : (0, _lodash.uniqueId)('__toggleSwitch_'); // labelA/labelB are suppose to accept nodes but they only accept strings.
    // Carbon bug: https://github.com/carbon-design-system/carbon/pull/6811

    var mappedLabelA = labelA != null ? labelA : '';
    /* this is against Carbon but needed for now */

    var mappedLabelB = labelB != null ? labelB : '';
    /* this is against Carbon but needed for now */

    var mappedOnChange = onToggle ? onChange : undefined;
    var mappedOnToggle = onToggle != null ? onToggle : onChange;
    var mappedTabIndex = tabIndex != null ? tabIndex : 0;
    var mappedToggled = (_ref = toggled != null ? toggled : checked) != null ? _ref : false;
    var hasCarbonLabelProps = !!(labelA || labelB || displayLabel);
    var mappedClassNameForFlex;
    var mappedClassNameForToggle = className;

    if (!hasCarbonLabelProps) {
      var classNames = (0, _utils.classnames)(toggleSwitchClassName);
      mappedClassNameForFlex = classNames + " " + (className != null ? className : '');
      mappedClassNameForToggle = undefined;
    }

    var Toggle = small ? _baUiCarbon.ToggleSmall : _baUiCarbon.Toggle;

    var carbonToggleWidget = /*#__PURE__*/_react["default"].createElement(Toggle, (0, _extends2["default"])({}, otherToggleProps, checkboxInputExtraOptions != null ? checkboxInputExtraOptions : {}, {
      className: mappedClassNameForToggle,
      disabled: mappedDisabled,
      id: mappedId,
      labelA: mappedLabelA,
      labelB: mappedLabelB,
      onChange: mappedOnChange,
      onToggle: mappedOnToggle,
      tabIndex: mappedTabIndex,
      toggled: mappedToggled
    }));

    if (hasCarbonLabelProps) {
      return carbonToggleWidget;
    } // Label hack (for pre 11.2.0 compatibility)
    // Basically: use deprecated 'label' prop (if applicable), remove top margin (see ToggleSwitch.scss)


    var mappedLabel = typeof label === 'string' ? /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], {
      value: label
    }) : label;
    return /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], {
      alignItems: "center",
      inline: true,
      className: mappedClassNameForFlex
    }, carbonToggleWidget, mappedLabel && /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: mappedId,
      style: {
        marginLeft: '8px'
      }
    }, mappedLabel));
  };

  return ToggleSwitch;
}(_react.Component);

exports["default"] = ToggleSwitch;
(0, _defineProperty2["default"])(ToggleSwitch, "propTypes", (0, _extends2["default"])({}, _baUiCarbon.Toggle.propTypes, {
  // focusable in sequential keyboard navigation */
  tabIndex: _propTypes["default"].number,

  /** Which Carbon toggle to use: true = ToggleSmall, false = Toggle */
  small: _propTypes["default"].bool,

  /** deprecated - no Carbon option */
  active: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - no Carbon option */
  align: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - just pass in the props */
  checkboxInputExtraOptions: BaPropTypes.deprecated('deprecated - just pass in the props'),

  /** deprecated - use Carbon prop toggled */
  checked: BaPropTypes.deprecated('deprecated - use Carbon prop toggled'),

  /** deprecated - use disabled */
  disabledSingular: BaPropTypes.deprecated('deprecated - use disabled'),

  /** deprecated - no Carbon option */
  hover: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - no Carbon option */
  indeterminate: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - use Carbon prop labelText */
  label: BaPropTypes.deprecated('deprecated - use Carbon prop labelText'),

  /** deprecated(sort of) - used as Toolkit prop returns a non-standard signature(bool), used as Carbon prop returns standard signature(event). Better to use onToggle signature(bool, id, event).' */
  onChange: BaPropTypes.deprecated('deprecated(sort of) - used as Toolkit prop returns a non-standard signature(bool), used as Carbon prop returns standard signature(event). Better to use onToggle signature(bool, id, event).'),

  /** deprecated - no Carbon option(maybe disabled) */
  readOnly: BaPropTypes.deprecated('deprecated - no Carbon option(maybe disabled)')
}));

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(558);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-toggleSwitch .bx--toggle__switch{margin-top:0}\n", ""]);

// exports
exports.locals = {
	"toggleSwitchClassName": "\"ba-toggleSwitch\""
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[554,0]]]);
});